type CompareResult = 0 | 1 | -1;

/**
 * the function compare strings in lower case
 */
export default function compareInLowercase(a:string, b: string):CompareResult {
  const aLower = a.toLowerCase();
  const bLower = b.toLowerCase();

  if (aLower < bLower) {
    return -1;
  }
  if (aLower > bLower) {
    return 1;
  }

  return 0;
}